const domain = process.env.REACT_APP_API_DOMAIN;
export const mainDomain = process.env.REACT_APP_DOMAIN;

export default domain;
